import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import NewInterventionModal from './NewInterventionModal';
import Toaster from './Toaster';
import { useSocketSync } from '@/hooks/useSocket';
import { useUiStore } from '@/stores/uiStore';

export default function AppShell() {
  useSocketSync();
  const newRdvModalOpen = useUiStore((s) => s.newRdvModalOpen);
  const defaultType = useUiStore((s) => s.newRdvDefaultType);
  const closeModal = useUiStore((s) => s.closeNewRdvModal);

  return (
    <div className="flex min-h-screen bg-surface-bg">
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <Outlet />
      </main>
      <NewInterventionModal
        open={newRdvModalOpen}
        onClose={closeModal}
        defaultTypeAgenda={defaultType}
      />
      <Toaster />
    </div>
  );
}
